import Dashboard from './views/Dashboard'
import Contacts from './views/Contacts'
import MergeContacts from './views/MergeContacts'

const CustomersRoutes = [
    {
        path: '/customers',
        component: () => import(/* webpackChunkName: "customers-module" */ './CustomersModule.vue'),
        children: [
            { path: '', name: 'Customers Dashboard', component: Dashboard },
            { path: 'contacts', name: 'Contacts', component: Contacts },
            { path: 'contacts/:contact_id', name: 'Contact Detail', component: Contacts, props: true },
            { path: 'merge-customers', name: 'Merge Customers', component: MergeContacts }
        ]
    }
]

export default CustomersRoutes
